import { useEffect, useState } from 'react';

import { Download } from "@mui/icons-material";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { Button, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { useNavigate } from 'react-router-dom';
import { Loading } from "../../components/Loading";
import { MyRenderCell } from "../../components/MyRenderCell";
import { IBatchShipped } from '../../models/batches/batchShipped';
import { RootState, downloadBatchesShippedDetails, getBatchesShipped } from "../../redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

export const BathchesShipped = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { isLoading, batchesShipped = [] } = useAppSelector((state: RootState) => state.batches);
    const [pageSize, setPageSize] = useState<number>(10);

    useEffect(() => {
        dispatch(getBatchesShipped() as any);
    }, [dispatch])

    const download = (batchShipped: IBatchShipped) => {
        dispatch(downloadBatchesShippedDetails(batchShipped.id, batchShipped.uniqueIdentifier));
    };

    const Columns: GridColDef[] = [
        {
            field: "action",
            headerName: "Actions",
            width: 140,
            sortable: false,
            align: "right",
            renderCell: (params) => {
                const onClick = (e: React.MouseEvent<HTMLElement>) => {
                    download(params.row as any);

                    e.stopPropagation();
                };
                const onDetails = (e: React.MouseEvent<HTMLElement>) => {
                    navigate("/bathchesShipped/details/" + params.row.batchId);

                    e.stopPropagation();
                };
                return (
                    <>
                        <Tooltip title="Download" >
                            <Button onClick={onClick}><Download /></Button>
                        </Tooltip>
                        <Tooltip title="Details" >
                            <Button onClick={onDetails}><FormatListNumberedIcon /></Button>
                        </Tooltip>
                    </>
                )
            }
        },
        {
            field: 'id',
            headerName: 'id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'uniqueIdentifier',
            headerName: 'Batch UniqueIdentifier',
            width: 320,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'sentDate',
            headerName: 'Sent Date',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'sequence',
            headerName: 'Sequence',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activityCode',
            headerName: 'Activity Code',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'masterActivity',
            headerName: 'MasterActivity',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'activitynumber',
            headerName: 'Activitynumber',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'batchDate',
            headerName: 'Batch Date',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
    ]



    return (
        <div>
            <Loading isLoading={isLoading} />
            <Typography variant="h4" component="h1">Batches Shipped</Typography>
            <br />
            <div style={{ height: "calc(100vh - 250px)", width: '100%', flexGrow: 1 }}>
                <DataGrid
                    rows={batchesShipped}
                    columns={Columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 50, 100]}
                    columnVisibilityModel={{ id: false, }}
                />
            </div>
        </div>
    )
}
